<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12">
          <GradeClassStudentSelect @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="d-flex justify-end">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { get } from 'lodash'
import { textHelpers } from '@/helpers/TextHelper'
import utils from '@/plugins/utils'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    GradeClassStudentSelect,
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    studentCode: '',
    studentName: '',
    selectedStatus: '',
  }),
  created() {
    // Default active
    this.selectedStatus = this.studentStatus[0].status
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
  },
  methods: {
    ...mapActions('students', ['requestPageSettings', 'getStudentCount']),
    ...mapMutations({
      setQuery: 'students/setQuery',
      setLoading: 'students/setLoading',
    }),
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    async onFilterChanged() {
      try {
        this.setLoading(true)
        const studentQueryParams = {}
        const queryCode = textHelpers.removeSpaces(this.studentCode)
        const queryName = textHelpers.removeSpaces(utils.clearUnicode(this.studentName))

        if (get(this.selectedClass, 'id', '')) studentQueryParams.currentClass = get(this.selectedClass, 'id', '')
        if (get(this.selectedStudent, 'id', '')) studentQueryParams._id = get(this.selectedStudent, 'id', '')
        if (get(this.selectedGrade, 'id', '')) studentQueryParams.grade = get(this.selectedGrade, 'id', '')
        if (queryCode) studentQueryParams.code_contains = queryCode
        if (queryName) studentQueryParams.tags_contains = queryName
        if (this.selectedStatus) studentQueryParams.status = this.selectedStatus
        this.setQuery(studentQueryParams)
        await this.requestPageSettings({ page: 1, itemsPerPage: 10 })
      } catch (e) {
        this.$alert.error(e)
      } finally {
        this.setLoading(false)
      }
    },
    gradeClassChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
    },
  },
  watch: {},
}
</script>

<style lang="scss" scoped></style>
